var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column h-100"},[_c('app-header'),_c('main',{staticClass:"flex-shrink-0",attrs:{"data-layout":"wide"}},[_vm._t("default")],2),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }